module.exports = __webpack_public_path__ + "static/sold_tag-d4b12789da9f4032846f56adf5fd4704.png";